<script>
// need to import all component use in backend
import HomepageForm from 'templates/components/HomepageForm';

export default {
    name: 'block_vuejs_component',
    components: { HomepageForm },
    props: {
        component: {
            type: String,
            required: true,
        },
    },
    render(createElement) {
        return createElement(
            this.component,
        );
    },
};
</script>
